/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import DataComponent from "../DataComponent";
import { get, isEmpty, forEach, isFunction, isNumber, isArray } from "lodash";
import classname from "classnames";
import Pagination from "../Pagination";
import CheckBox from "../CheckBox/idnex";

import SVG from "react-inlinesvg";
import arrowBoxIcon from "../../assets/images/icon/arrow-box-icon.svg";
import TableSortIcon from "../../assets/images/icon/table-sort-icon.svg";
import Loading from "../Loading";
import NoData from "../NoData/NoData";
import DeleteButton from "../../assets/images/icon/delete-btn.svg";
import EditButton from "../../assets/images/icon/edit-btn.svg";
import CheckButton from "../../assets/images/icon/arrow-box-icon.svg";
import Icon from "../Icon";
import Radio from "../Radio/Radio";
import { classnames } from "../../utils/text";
import { hasParents, preventEvent } from "../../utils/element";
import IconButton from "../Button/IconButton";
import ToolTip from "../ToolTip/ToolTip";

const ControlTable = ({
  ExpandData,
  isHideHeader = false,
  isDefaultOpen = true,
  isOpenToggle = false,
  isLoading = false,
  isHideAllCheck = false,
  isHidePagination = false,
  loadingColor,
  onSelect,
  isHideControlHeader = false,
  noDataText,
  className = "",
  rowActiveAction,
  isReaction = false,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(isDefaultOpen);
  const [allCheck, setAllCheck] = useState(false);
  const [checkedRow, setCheckedRow] = useState([]);
  const [isExpand, setIsExpand] = useState({
    open: false,
    idx: null,
  });
  const table = useRef(null);
  const [tableHeight, setTableHeight] = useState(200);

  useEffect(() => {
    setAllCheck(false);
    setCheckedRow([]);

    if (props.selectedList && isNumber(props.page)) {
      props.setSelected([]);
    }
  }, [props.page]);

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => {
        if (table && table.current) {
          setTableHeight(table.current.offsetHeight);
        }
      }, 500);
    }
  }, [isLoading]);
  useEffect(() => {
    if (!isEmpty(props.list)) {
      const { page, limit, total, list } = props;
      const startIndex = page * limit + 1;
      const maxIndex = Math.min(startIndex + limit, total);
      list.forEach((item, idx) => {
        item.index = maxIndex - idx;
      });
    }
  }, [props.list, props.page, props.limit, props.total]);

  const handleOnAllCheck = (checked) => {
    setAllCheck(!allCheck);

    if (checked) {
      props.setSelected(props.list);
      forEach(props.list, (d, i) => {
        setCheckedRow((rowIdx) => [...rowIdx, i]);
      });
    } else {
      props.setSelected([]);
      setCheckedRow([]);
    }
  };

  useEffect(() => {
    // allcheck 관련 수정...
    if (!isEmpty(props.list)) {
      if (get(props, 'list.length') === get(props, 'selectedList.length')) {
        setAllCheck(true);
      } else setAllCheck(false);
    }
  }, [props.list, props.selectedList]);

  const _onSelect = (data, e, idx) => {
    if (isFunction(onSelect)) {
      // onSelect 호출시 부모가 checkbox 에 관련이면 실행되지 않음.
      if (!hasParents(e.target, "checkbox")) {
        if (e.target.classList.contains('checkbox')) {
          const checkbox = e.target.children[0].children[0].children[0];
          let checked = checkbox.checked;
          const disabled = checkbox.disabled;
          if (disabled) return;
          checked = !checked;
          handleOnCheck(checked, data, idx, e);
        } else {
          onSelect(data, e);
        }
      }
    }
  };
  const handleOnCheck = (checked, data, idx, e) => {
    //console.log("[Table] checked : ", checked, data, idx);
    // TODO check event 버블링 막아야함
    // preventEvent(e);

    if (allCheck) {
      setAllCheck(false);
      props.setSelected(props.selectedList.filter(
        (d) => (isFunction(rowActiveAction) ? !rowActiveAction(data, d) : true) && d !== data
      ));

      setCheckedRow(checkedRow.filter((r) => r !== idx));
    } else {
      if (checked) {
        props.setSelected((oldValues) => [...oldValues, data]);
        setCheckedRow((rowIdx) => [...rowIdx, idx]);
      } else {
        props.setSelected(props.selectedList.filter(
          (d) => (isFunction(rowActiveAction) ? !rowActiveAction(data, d) : true) && d !== data
        ));
        setCheckedRow(checkedRow.filter((r) => r !== idx));
      }
    }
  };

  const toggleExpand = (idx) => {
    if (isExpand.idx === idx) {
      setIsExpand({
        open: false,
        idx: null,
      });
    } else {
      setIsExpand({
        open: true,
        idx,
      });
    }
  };

  return (
    <div
      className={classnames(`control-table-container ${!isOpen ? "close-table" : ""} ${props.mt ? `mt-${props.mt}` : ""}`, className)}
    >
      {!isHideControlHeader && (
        <div className="control-header">
          <div className="control-header-box">
            {props.isControl && isHideHeader && !isHideAllCheck && (
              <CheckBox
                id={"checkAll"}
                checked={allCheck}
                onChange={handleOnAllCheck}
              />
            )}
            {!isEmpty(get(props, "title")) &&
              isEmpty(get(props, "selectedList")) && (
                <div className="table-title">{isFunction(get(props, "title")) ? props.title() : get(props, 'title')}</div>
              )}
            {!isEmpty(get(props, "selectedList")) && (
              <div className="control-selected">
                <span className="selected-text">{props.selectedList.length}</span>
                개 선택됨
              </div>
            )}
            {isOpenToggle && (
              <span className="toggle-button">
                <DataComponent
                  field={{
                    type: "button",
                    color: "text",
                    size: "x-sm",
                    onClick: () => {
                      setIsOpen(!isOpen);
                    },
                    label: <SVG src={arrowBoxIcon} />,
                  }}
                />
              </span>
            )}
          </div>
          <div className="control-btn-items">
            {!isEmpty(get(props, "buttons")) &&
              get(props, "buttons").map((button, idx) => (
                (isFunction(button.isHide) && button.isHide()) ||
                  (!isFunction(button.isHide) && button.isHide) ?
                  <React.Fragment key={`hide-button-${idx}`}></React.Fragment>
                  :
                  // <Button
                  //   key={idx}
                  //   label={button.label}
                  //   onClick={button.action}
                  //   disabled={button.isDisabled || button.disabled}
                  //   {...button}
                  // />
                  <DataComponent
                    key={idx}
                    field={{
                      type: "button",
                      ...button,
                    }}
                  />
              ))}
          </div>
        </div>
      )}
      {isLoading ? (
        <Loading color={loadingColor} minHeight={tableHeight} />
      ) : isEmpty(props.list) ? (
        <NoData text={noDataText} />
      ) : (
        <table className={classnames("table", { isHideControlHeader })} ref={table}>
          {!isHideHeader && (
            <thead>
              <tr>
                {props.isSelect && <th className="padding-left-24">선택</th>}
                {props.isControl && (
                  <th className="table-action-warp checkbox">
                    {!isHideAllCheck && (
                      <CheckBox checked={allCheck} onChange={handleOnAllCheck} />)}
                  </th>
                )}
                {props.isExpand && <th className="table-action-warp"></th>}
                {!isEmpty(props.fields) &&
                  props.fields.map((field, idx) => (
                    (isFunction(field.isHide) && field.isHide()) ||
                      (!isFunction(field.isHide) && field.isHide) ?
                      <React.Fragment key={`hide-table-header-${idx}`}></React.Fragment>
                      :
                      <th key={idx} style={{ width: props.fields.width }}>
                        <span className={classnames("table-head-title", { cursor: field.sort })} onClick={() => {
                          isFunction(field.sort) && field.sort(field.key);
                        }}>
                          {field.title}
                        </span>
                        {field.sort && (
                          <IconButton
                            className={classnames("table-sort-icon ml-4", isFunction(field.order) && field.order(field.key), {
                              selected: (field.sortKey || field.key) === get(props, 'sortField.key')
                            })}
                            icon={TableSortIcon}
                            action={() => {
                              isFunction(field.sort) && field.sort(field.key);
                            }} />
                        )}
                        {field.tooltip && (
                          <ToolTip {...field.tooltip} />
                        )}
                      </th>
                  ))}
                {props.rowBtn && (
                  <th style={{ width: props.rowBtn.width }}>{get(props.rowBtn, 'title')}</th>
                )}
              </tr>
            </thead>
          )}
          <tbody>
            {!isEmpty(props.notices) &&
              props.notices.map((data, idx) => (
                <React.Fragment key={idx}>
                  <tr
                    className={classname("", {
                      activeRow:
                        (props.selectedList &&
                          props.selectedList.includes(data)) ||
                        (props.selected && props.selected === data)
                    })}
                    style={onSelect && { cursor: "pointer" }}
                    onClick={(e) => _onSelect(data, e, idx)}
                  >
                    {(props.isControl || props.isExpand || props.isSelect) && (
                      <td
                        className={classnames(`vertical-middle`)}
                      >-</td>
                    )}
                    {!isEmpty(props.fields) &&
                      props.fields.map((field, idx) => (
                        (isFunction(field.isHide) && field.isHide()) ||
                          (!isFunction(field.isHide) && field.isHide) ?
                          <React.Fragment key={`hide-table-cell-${idx}`}></React.Fragment>
                          :
                          <td
                            key={idx}
                            className={classnames(
                              isFunction(field.className) ? field.className(data) : field.className,
                              `vertical-${field.valign || "middle"}`
                            )}
                            align={field.align}
                            style={{
                              width: field.width || 'auto',
                              ...(field?.style || {})
                            }}
                          >
                            {field.key === 'index' ? <span className="color-red-100 font-bold">공지</span> :
                              <DataComponent field={field} data={data} />
                            }
                          </td>
                      ))}
                  </tr>
                  {props.isExpand && isExpand.open && idx === isExpand.idx && (
                    <tr className="expand-row">
                      <td colSpan={props.expandCol}>
                        <div className="expand-container">
                          <ExpandData data={data} />
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            }

            {!isEmpty(props.list) &&
              props.list.map((data, idx) => {
                return (
                  <React.Fragment key={idx}>
                    <tr
                      className={classname("", {
                        activeRow:
                          (props.selectedList &&
                            props.selectedList.includes(data)) ||
                          (props.selected && props.selected === data) ||
                          (isFunction(rowActiveAction) && rowActiveAction(data))
                      })}
                      style={onSelect && { cursor: "pointer" }}
                      onClick={(e) => _onSelect(data, e, idx)}
                    >
                      {props.isSelect && (
                        <td className={classnames("table-radio vertical-middle")}>
                          <div className="component-radio-wrap">
                            <Radio
                              field={{
                                key: "table-radio",
                                defaultChecked: "",
                                onChange: (e) => {
                                  props.setSelectedData(
                                    props.list[e.target.value]
                                  );
                                },
                                ...(props.isSelect || {})
                              }}
                              className=" margin-right-0"
                              value={idx}
                            />
                          </div>
                        </td>
                      )}
                      {props.isControl && (
                        <td className={`checkbox vertical-${"middle"}`}>
                          <CheckBox
                            checked={props.selectedList.includes(data) || (isFunction(rowActiveAction) && rowActiveAction(data))}
                            onChange={(check, value, e) => {
                              handleOnCheck(check, data, idx, e);
                            }}
                            disabled={
                              isFunction(props.checkboxDisabled)
                                ? props.checkboxDisabled(data)
                                : false
                            }
                          />
                        </td>
                      )}
                      {props.isExpand && (
                        <td className={`table-action-warp vertical-${"middle"}`}>
                          <span
                            className={classname(`expand-btn `, {
                              open: isExpand.open && idx === isExpand.idx,
                            })}
                            onClick={() => toggleExpand(idx)}
                          />
                        </td>
                      )}
                      {!isEmpty(props.fields) &&
                        props.fields.map((field, idx) => (
                          (isFunction(field.isHide) && field.isHide()) ||
                            (!isFunction(field.isHide) && field.isHide) ?
                            <React.Fragment key={`hide-table-cell-${idx}`}></React.Fragment>
                            :
                            <td
                              key={idx}
                              className={classnames(
                                isFunction(field.className) ? field.className(data) : field.className,
                                `vertical-${field.valign || "middle"}`
                              )}
                              align={field.align}
                              style={{
                                width: field.width || 'auto',
                                ...(field.style || {})
                              }}
                            >
                              <DataComponent field={field} data={data} />
                            </td>
                        ))}
                      {props.rowBtn && (
                        <td className="row-btn-td">
                          {isArray(props.rowBtn.rowButtons) &&
                            props.rowBtn.rowButtons.map((btn, indexKey) => (
                              <React.Fragment key={indexKey}>
                                {btn.type === "delete" && (
                                  (isFunction(btn.isHide) && btn.isHide(data)) ||
                                    (!isFunction(btn.isHide) && btn.isHide) ?
                                    <></>
                                    :
                                    (
                                      <button
                                        className={classnames(
                                          "icon-button",
                                          btn.className
                                        )}
                                        type="button"
                                        onClick={(e) => {
                                          preventEvent(e);
                                          btn.action(data);
                                        }}
                                        disabled={btn.disabled}
                                      >
                                        <Icon src={DeleteButton} />
                                      </button>
                                    ))}
                                {btn.type === "edit" && (
                                  (isFunction(btn.isHide) && btn.isHide(data)) ||
                                    (!isFunction(btn.isHide) && btn.isHide) ?
                                    <></>
                                    :
                                    <button
                                      className={classnames(
                                        "icon-button",
                                        btn.className
                                      )}
                                      type="button"
                                      onClick={(e) => {
                                        preventEvent(e);
                                        btn.action(data);
                                      }}
                                      disabled={btn.disabled}
                                    >
                                      <Icon src={EditButton} />
                                    </button>
                                )}
                                {btn.type === "check" && (
                                  (isFunction(btn.isHide) && btn.isHide(data)) ||
                                    (!isFunction(btn.isHide) && btn.isHide) ?
                                    <></>
                                    :
                                    <button
                                      className={classnames(
                                        "icon-button",
                                        "check-icon-button",
                                        isFunction(btn.className) ? btn.className(data) : btn.className
                                      )}
                                      type="button"
                                      onClick={(e) => {
                                        preventEvent(e);
                                        btn.action(data);
                                      }}
                                      disabled={btn.disabled}
                                    >
                                      <Icon src={CheckButton} />
                                    </button>
                                )}
                              </React.Fragment>
                            ))}
                        </td>
                      )}
                    </tr>
                    {isReaction && (
                      <tr style={{ height: "auto" }} className="expand-row">
                        <td colSpan={props?.fields.length + (!isEmpty(props.rowBtn) ? 1 : 0)}
                          style={{
                            textAlign: "left",
                            verticalAlign: "middle",
                            paddingLeft: 100,
                          }}
                        >

                          <DataComponent
                            field={
                              { type: "reaction" }
                            }
                            form={data}
                            params={{
                              postIdx: "idx",
                              postType: "counseling"
                            }}
                          />
                        </td>
                      </tr>
                    )}
                    {props.isExpand && isExpand.open && idx === isExpand.idx && (
                      <tr className="expand-row">
                        <td colSpan={props.expandCol}>
                          <div className="expand-container">
                            <ExpandData data={data} />
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            {props.resultRow && (
              <tr className="result-row">
                {(props.isExpand || props.isControl) && <td></td>}
                {!isEmpty(props.fields) &&
                  props.fields.map((field, idx) => (
                    <td
                      key={idx}
                      className={classnames(field.className, `vertical-${field.valign || "middle"}`)}
                      align={field.align}
                      width={field.width}
                    >
                      <DataComponent field={field} data={props.resultRow} />
                    </td>
                  ))}
              </tr>
            )}
          </tbody>
        </table>
      )}
      {!isHidePagination && isNumber(get(props, "page")) && (
        <Pagination
          className={classnames({ hide: !isEmpty(props.list) })}
          total={props.total}
          page={props.page}
          limit={props.limit}
          setPage={props.setPage}
          setLimit={props.setLimit}
          submit={props.submit}
        />
      )}
    </div>
  );
};

export { ControlTable };
